import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { filter, switchMap } from 'rxjs/operators';
import { ClientService } from 'src/app/domain/services';
import { GoogleAnalyticsService } from 'src/app/shared/service/google-analytics.service';
import { Program } from '../../../program/models/program.model';
import { ProgramService } from '../../../program/services/program.service';
import { ProviderSearch } from '../../models';

@Component({
    selector: 'app-provider-search',
    templateUrl: './provider-search.component.html',
    styleUrls: ['./provider-search.component.scss'],
    standalone: false
})
export class ProviderSearchComponent implements OnInit {
    @Output()
    searchEvent: EventEmitter<ProviderSearch> =
        new EventEmitter<ProviderSearch>();

    @Input()
    set formattedSearchAddress(value: string | undefined) {
        if (value && this.searchParams.address != value)
            this.searchParams.address = value;
    }

    programs: Program[] | undefined;
    selectedPrograms: Program[] | undefined;
    distanceSearch: string | undefined;
    searchParams: ProviderSearch = new ProviderSearch();
    programsControl: UntypedFormControl = new UntypedFormControl();

    constructor(
        private _programs: ProgramService,
        private _googleAnalyticsService: GoogleAnalyticsService,
        private _client: ClientService
    ) {}

    ngOnInit(): void {
        this._googleAnalyticsService.pageView('Provider Search');
        this._client.latest
            .pipe(
                filter((client) => client !== null && client !== undefined),
                switchMap(() => this._programs.getPrograms())
            )
            .subscribe((result) => {
                this.programs = result;
                if (sessionStorage.getItem('selectedProgramIds')) {
                    this.setDefaultProgramSelectionFromProgramPage(
                        this.programs
                    );
                    this.search();
                } else {
                    sessionStorage.removeItem('applicationProgramIds');
                    this.search();
                }
            });
    }

    clearProviderSearch() {
        this.searchParams.searchText = '';
        this.search();
    }
    clearAddress() {
        this.searchParams.address = '';
        this.search();
    }

    search() {
        this._googleAnalyticsService.search(
            'Provider Search',
            this.searchParams.searchText,
            this.searchParams.address
        );

        this.searchParams.programIds = [];
        this.selectedPrograms?.forEach((x) => {
            if (x.programId) {
                this.searchParams.programIds?.push(x.programId);
            }
        });

        this.searchParams.distance = this.distanceSearch
            ? parseInt(this.distanceSearch)
            : 0;

        // store provider Ids in sessionStorage
        if (this.searchParams.programIds.length > 0)
            sessionStorage.setItem(
                'applicationProgramIds',
                this.searchParams.programIds.toString()
            );
        else sessionStorage.removeItem('applicationProgramIds');

        this.searchEvent.emit(this.searchParams);
    }

    removeProgram(index: number) {
        this.selectedPrograms?.splice(index, 1);
        this.programsControl?.setValue(this.selectedPrograms);
        this.search();
    }

    private setDefaultProgramSelectionFromProgramPage(programs: Program[]) {
        // programs selected on Program page are stored in sessionStorage
        const idsFromProgramPage = sessionStorage
            .getItem('selectedProgramIds')
            ?.split(',')
            .map(Number);

        // remove the key from storage since we don't need that to persist after this point
        sessionStorage.removeItem('selectedProgramIds');

        // select the programs
        this.selectedPrograms = programs.filter(function (x) {
            return x.programId && idsFromProgramPage?.includes(x.programId);
        });

        this.programsControl?.setValue(this.selectedPrograms);
    }
}
